import { fetch } from "src/services/apollo-fetch";
import { Query, Mutation } from "../_api";

export default {
    async fetchSettings() {
        const response = await fetch.query({
            query: Query.settings,
        });
        return response.data.settings;
    },
    async updateSettings(context, data) {
        const response = await fetch.mutate({
            mutation: Mutation.updateSettings,
            variables: data,
        });
        return response.data.updateSettings;
    },
};
